<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" class="no-field-space projectposition-editor">
    <sc-dialog-title>
        {{ 'Project Position' | translate: ['erp.ui.projectposition-editor.title', translationService.language]}}
    </sc-dialog-title>
    <sc-separator-line></sc-separator-line>

  <sc-flex-fitting-content [vertical]="true">
    <form [formGroup]="formGroup" style="height: 100%;">
      <sc-flex [stretchContent]="true" [fitHeight]="true">
        <sc-scroll-pane class="left-column">
          <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
            <sc-padding>
              <sc-sub-title>
                {{ 'Eigenschaften' | translate: ['erp.ui.projectposition-editor.subtitle.attributes',
                translationService.language]}}
              </sc-sub-title>
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
              <sc-checkbox-field formControlName="notBillingRelevant" [label]="'nicht abrechnungsrelevant' | translate: ['erp.ui.projectposition-editor.label.non-billing-relevant',
                translationService.language]"></sc-checkbox-field>
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
              <sc-flex [vertical]="true" [stretchContent]="true">
                <app-date-chooser-field controlName="referenceDate" label="Leistungsdatum" [formGroup]="formGroup"
                  [required]="true">
                </app-date-chooser-field>
                <ng-container *ngFor="let group of attributeGroupsPosition">
                  <app-attribute-group [formGroup]="formGroup" [attributeGroup]="group" [valuesMap]="position.valuesMap"
                    [usage]="group.usage"></app-attribute-group>
                </ng-container>
                <sc-content-spacer [vertical]="true"></sc-content-spacer>
                <div class="article-field">
                  <sc-padding>
                    <sc-flex>
                      <div class="text-selection">
                        <div class="article-field-label">{{ 'Artikel' | translate:
                          ['erp.entity.projectposition.article',
                          translationService.language]}}</div>
                        {{article?.identifier}}
                      </div>
                      <sc-content-spacer [grow]="true"></sc-content-spacer>
                      <sc-action-icon iconClass="fa-search" (click)="searchArticle()">
                      </sc-action-icon>
                    </sc-flex>
                  </sc-padding>
                </div>
              </sc-flex>
            </sc-padding>
          </sc-flex>
        </sc-scroll-pane>
        <sc-flex-fitting-content>
          <sc-padding [fitHeight]="true">
            <sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true">
              <sc-sub-title>
                {{ 'Preis der Position' | translate: ['erp.ui.projectposition-editor.subtitle.priceeditor',
                translationService.language]}}
              </sc-sub-title>
              <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
              <div>
                <sc-flex>
                  <mat-form-field appearance="fill">
                    <mat-label>{{ 'Anzahl' | translate: ['erp.entity.projectposition.count',
                      translationService.language]}}</mat-label>
                    <input matInput acNumberInput [scale]="0" formControlName="count" required="true">
                  </mat-form-field>
                  <sc-content-spacer></sc-content-spacer>
                  <mat-form-field appearance="fill" [ngStyle]="{'flex-grow': 1}">
                    <mat-label>{{ 'Beschreibung' | translate: ['erp.entity.projectposition.description',
                      translationService.language]}}</mat-label>
                    <input matInput formControlName="description">
                  </mat-form-field>
                </sc-flex>
              </div>
              <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
              <sc-flex-fitting-content [vertical]="true">
                <app-price-editor [formGroup]="formGroup" [article]="article" [projectPosition]="position"
                  [referenceDate]="referenceDate" [amount]="count"></app-price-editor>
              </sc-flex-fitting-content>
            </sc-flex>
          </sc-padding>
        </sc-flex-fitting-content>
      </sc-flex>
    </form>
  </sc-flex-fitting-content>
  <sc-separator-line></sc-separator-line>
  <sc-actionbar>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button (click)="onClose()">
        {{ 'Abbrechen' | translate: ['erp.ui.projectposition-editor.action.cancel', translationService.language]}}
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled">
        {{ 'Übernehmen' | translate: ['erp.ui.projectposition-editor.action.confirm', translationService.language]}}
      </button>
  </sc-actionbar>
</sc-flex>
